import React, { useState } from "react";
import {
  Table,
  Input,
  InputNumber,
  Flex,
  AutoComplete,
  Popover,
  Select,
  Button,
  notification,
} from "antd";
import useData from "../../hooks/useData";

import "./style.scss";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

const RequestPage = () => {
  const { _id } = useAuthUser();
  const [requests, setRequests] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { data, isLoading } = useData(
    `/products/autocomplete?q=${searchValue}`,
    [],
  );
  const { update } = useData("/products/purchaseRequest", []);
  const [api, contextHolder] = notification.useNotification();
  const { data: dealers } = useData("/products/dealers", []);

  const handleAdd = async () => {
    const result = await update({
      author: _id,
      products: requests.map((item) => ({
        itemId: item._id || 0,
        name: item.name,
        quantity: item.quantity,
        file: item.file || null,
        category: item.category || null,
        price: item.price,
        dealer: item.dealer,
        comment: item.comment,
        code: item.code,
      })),
      date: new Date(),
      totalAmount,
    });
    if (result) {
      window.location.href = "/purchase/list";
      api.success({
        message: "Успешно",
        description: "Заявка на закупку успешно отправлена",
      });
    }
  };

  const handleAddRow = (v, z) => {
    setSearchValue("");
    if (requests.filter((item) => item.name === z.name).length > 0) {
      api.warning({
        message: "Ошибка",
        description: `"${z.name}" уже добавлен в список`,
      });
    } else {
      setRequests([
        ...requests,
        {
          ...z,
          id: Date.now(),
          quantity: "",
          comment: "",
          locked: false,
        },
      ]);
    }
  };

  const handleChange = (value, key, id) => {
    const updatedRequests = requests.map((item) => {
      if (item.id === id) {
        if (key === "name") {
          const selectedProduct = data.find((product) => product._id === value);
          return {
            ...item,
            name: selectedProduct?.name,
            price: selectedProduct?.price,
            dealer: selectedProduct?.dealer,
          };
        }
        return { ...item, [key]: value };
      }
      return item;
    });
    setRequests(updatedRequests);
  };

  const totalAmount = requests.reduce(
    (sum, item) => sum + (item.quantity * item.price || 0),
    0,
  );

  const columns = [
    {
      title: "№",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      width: 500,
      render: (text, record) => (
        <Flex gap={12} align={"center"}>
          {record?.file ? (
            <Popover
              zIndex={3000}
              placement={"right"}
              content={
                <>
                  <img
                    src={record.file}
                    width={200}
                    height={200}
                    style={{
                      background: "#FFF",
                      maxWidth: "100%",
                      height: "auto",
                    }}
                    alt={record.name}
                  />
                </>
              }
            >
              <img
                src={record.file}
                width={32}
                height={32}
                style={{
                  background: "#FFF",
                  maxWidth: "100%",
                  height: "auto",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: 2,
                }}
              />
            </Popover>
          ) : null}
          <Flex vertical>
            <div>{record.name}</div>
            <span style={{ fontSize: 12, color: "#999" }}>{record.code}</span>
          </Flex>
        </Flex>
      ),
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record) => (
        <InputNumber
          type="number"
          value={record.quantity}
          onChange={(value) =>
            handleChange(Number(value), "quantity", record.id)
          }
          min={0}
          disabled={record.locked}
        />
      ),
    },
    {
      title: "Цена за единицу",
      dataIndex: "price",
      key: "price",
      render: (text, record) => (
        <InputNumber
          type="number"
          value={record.price}
          suffix="₾"
          onChange={(e) => handleChange(e, "price", record.id)}
        />
      ),
    },
    {
      title: "Магазин",
      dataIndex: "dealer",
      key: "dealer",
      render: (text, record) => (
        <Select
          options={dealers?.map((d) => ({ label: d.name, value: d._id }))}
          value={record.dealer}
          onChange={(e) => handleChange(e, "dealer", record.id)}
          allowClear
          showSearch
          style={{ width: "100%" }}
        />
      ),
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
      render: (text, record) => (
        <Input
          value={record.comment}
          onChange={(e) => handleChange(e.target.value, "comment", record.id)}
          disabled={record.locked}
        />
      ),
    },
    {
      title: "Действия",
      key: "actions",
      render: (text, record) => (
        <Flex gap={8}>
          <Button
            danger
            type={"primary"}
            ghost
            icon={<DeleteOutlined />}
            onClick={async () => {
              if (record.quantity) {
                const result = await Swal.fire({
                  title: `Вы действительно хотите удалить эту линию?`,
                  text: "Это действие невозможно отменить",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Изменить статус",
                  cancelButtonText: "Отмена",
                });
                if (result.isConfirmed) {
                  setRequests(requests.filter((item) => item.id !== record.id));
                }
              } else {
                setRequests(requests.filter((item) => item.id !== record.id));
              }
            }}
          >
            Удалить
          </Button>
        </Flex>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header transfer">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Заявка на закупку</h4>
            </div>
          </div>
        </div>
        {contextHolder}
        <AutoComplete
          style={{ width: "100%", marginBottom: 32 }}
          options={
            searchValue.length > 2
              ? [
                  {
                    label: (
                      <Flex gap={6}>
                        <PlusOutlined />
                        <div>
                          Добавить <b>{searchValue}</b>
                        </div>
                      </Flex>
                    ),
                    value: 0,
                    name: searchValue,
                  },
                  ...data.map((product) => ({
                    ...product,
                    label: (
                      <Flex gap={12} align={"center"}>
                        {product?.file ? (
                          <Popover
                            zIndex={3000}
                            placement={"right"}
                            content={
                              <>
                                <img
                                  src={product.file}
                                  width={200}
                                  height={200}
                                  style={{
                                    background: "#FFF",
                                    maxWidth: "100%",
                                    height: "auto",
                                  }}
                                />
                              </>
                            }
                          >
                            <img
                              src={product.file}
                              width={44}
                              height={44}
                              style={{
                                background: "#FFF",
                                maxWidth: "100%",
                                height: "auto",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: 2,
                              }}
                            />
                          </Popover>
                        ) : null}
                        <Flex vertical gap={0}>
                          <div>{product.name}</div>
                          <div style={{ fontSize: 12, color: "#999" }}>
                            {product?.code} {product.category}
                          </div>
                        </Flex>
                      </Flex>
                    ),
                    value: product._id,
                  })),
                ]
              : undefined
          }
          onSelect={handleAddRow}
          value={searchValue}
        >
          <Input.Search
            size={"large"}
            value={searchValue}
            onSearch={(e) => setSearchValue(e)}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder={"Введите название товара"}
            loading={isLoading}
            enterButton={"Поиск"}
          />
        </AutoComplete>
        <Table
          dataSource={requests}
          columns={columns}
          rowKey="id"
          pagination={false}
        />
        <Flex justify={"space-between"} align={"center"} className={"mt-2"}>
          <div style={{ marginTop: 20, fontSize: "18px", fontWeight: "bold" }}>
            Итоговая сумма: {totalAmount} ₾
          </div>
          <Button
            type={"primary"}
            color={"green"}
            shape={"round"}
            size="large"
            onClick={handleAdd}
          >
            Отправить заявку
          </Button>
        </Flex>
      </div>
    </div>
  );
};

export default RequestPage;
